import { minBy } from 'lodash';

import { PricePlan, UserPricingPlan } from '../../../types/hubTypes';
import { calculatePlanDiscount } from '../../../views/account/ChangePricingPlanPage/helper';

export function canTransitionToCheaperPlan(
  currentPricingPlan: UserPricingPlan,
  allowedPlansForTransition: PricePlan[]
) {
  if (!currentPricingPlan || !allowedPlansForTransition || allowedPlansForTransition.length === 0) {
    return false;
  }
  const cheapestPlan = minBy(allowedPlansForTransition, 'privatePriceTier.costPerSession');
  const disc = calculatePlanDiscount(currentPricingPlan, cheapestPlan);
  return disc > 0;
}
